import React from 'react';
import Switch from '@mui/material/Switch';
import { styled } from '@mui/material/styles';
import { Tooltip } from '@mui/material';

const IOSSwitch = styled((props) => (
    <Switch focusVisibleClassName='.Mui-focusVisible' disableRipple {...props} />
))(({ theme }) => ({
    width: 95,
    height: 24,
    padding: 0,
    position: 'relative',

    '& .MuiSwitch-switchBase': {
        padding: 2,
        transitionDuration: '300ms',
        '&.Mui-checked': {
            transform: 'translateX(70px)',
            '& + .MuiSwitch-track': {
                backgroundColor: 'rgba(13, 71, 161, 1)',
                opacity: 1,
                border: 0,
                '&::before': { opacity: 1 },
                '&::after': { opacity: 0 },
            },
        },
        '&:not(.Mui-checked) + .MuiSwitch-track': {
            '&::before': { opacity: 0 },
            '&::after': { opacity: 1 },
        },
    },

    '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: 20,
        height: 20,
        backgroundColor: '#FFFFFF',
        transition: 'background-color 0.3s',
    },

    '& .MuiSwitch-track': {
        borderRadius: 26 / 2,
        backgroundColor: '#E9E9EA',
        opacity: 1,
        position: 'relative',
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        transition: theme.transitions.create(['background-color'], {
            duration: 500,
        }),

        '&::before, &::after': {
            position: 'absolute',
            top: '50%',
            transform: 'translateY(-50%)',
            fontSize: '10px',
            fontWeight: 600,
            textTransform: 'uppercase',
            transition: 'opacity 0.3s',
            opacity: 0,
        },

        '&::before': {
            content: '\'selected\'',
            left: 10,
            color: '#fff',
        },

        '&::after': {
            content: '\'uploaded\'',
            right: 8,
            color: 'rgba(13, 71, 161, 1)',
        },
    },
}));

const GoldStandardSwitch = ({ checked, onChange, ...props }) => {
    return (
        <Tooltip
            title={`Switch to the ${checked ? 'uploaded' : 'selected'} Gold Standard.\nClick on the Save button to Update Gold Standard.`}
            placement="top"
            slotProps={{
                popper: {
                    modifiers: [{ name: 'offset', options: { offset: [0, -14] } }],
                },
            }}
        >
            <label style={{ display: 'inline-block', cursor: 'pointer' }}>
                <IOSSwitch
                    checked={checked}
                    onChange={onChange}
                    sx={{
                        '& .MuiSwitch-thumb': {
                            backgroundColor: checked
                                ? '#FFFFFF'
                                : 'rgba(13, 71, 161, 1)',
                        },
                    }}
                    {...props}
                />
            </label>
        </Tooltip>
    );
};

export default GoldStandardSwitch;
